// @flow

// Todo:
// current implementation is very poor written and cn be used only in rare cases
// see packages/images for better implementation

import * as React from 'react';
import { useLog } from './log';

const hasIntersectionObserver = typeof IntersectionObserver !== 'undefined';

export const useHasBeenVisible = (
  ref: {| current: HTMLElement | null |},
  margin: number = 0,
): boolean => {
  const [result, setResult] = React.useState(false);

  React.useEffect(() => {
    if (result === true || ref.current == null) {
      return;
    }
    const element = ref.current;

    if (!hasIntersectionObserver) {
      setResult(true);
      return;
    }

    const options = {
      root: null,
      rootMargin: `${margin}px`,
      threshold: 0.01,
    };

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setResult(true);
        }
      });
    }, options);

    observer.observe(element);
    return () => observer.disconnect();
  }, [ref, margin, result]);

  return result;
};

export const useIsVisible = <T: HTMLElement>(
  eltRef: {| current: T | null |},
  initialVisibility: boolean,
): boolean => {
  const [isVisible, setIsVisible] = React.useState(initialVisibility);
  const logger = useLog();

  React.useEffect(() => {
    if (!hasIntersectionObserver) {
      setIsVisible(true);
      return;
    }

    if (eltRef.current == null) {
      logger.warn('useIsVisible must receive non null ref');
      return;
    }
    const element = eltRef.current;

    const rootMarginNum = 800;

    const options = {
      root: null,
      rootMargin: `${rootMarginNum}px`, // 200 load at 200px before entering the screen
      threshold: 0.01,
    };

    const handleIntersect = entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersect, options);

    observer.observe(element);

    return () => observer.disconnect();
  }, [eltRef, logger]);

  return isVisible;
};
